const VALID_PROVIDERS = ['google', 'microsoft']

export const validateProvider = (provider) => {
  if (!VALID_PROVIDERS.includes(provider)) {
    throw new Error('Invalid provider, must be one of ' + JSON.stringify(VALID_PROVIDERS))
  }
}
